import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EmailIcon from '@material-ui/icons/Email';
import BlockIcon from '@material-ui/icons/Block';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { mask } from 'remask';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { XMEI_PRIMARY_COLOR, UFS } from '../../consts/common';
import HeadTable from '../../components/HeadTable';
import { instanceAxios } from '../../InstanceAxios';
import IBGE from '../../services/IBGE';
import { isEmptyObject } from '../../utils/common';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
}));

function EmailPrefeitura() {
  const classes = useStyles();
  const [empresas, setEmpresas] = useState([]);
  const [cidadesEmail, setCidadesEmail] = useState({});
  const [alert, setAlert] = useState(false);
  const [msgAlert, setMsgAlert] = useState('');
  const [typeAlert, setTypeAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [columns, setColumns] = useState([
    { id: 'usuario', label: 'Usuario', minWidth: 140 },
    { id: 'empresa', label: 'Empresa', minWidth: 140 },
    { id: 'cnpj', label: 'CNPJ', minWidth: 140 },
    { id: 'emailEnviado', label: 'Enviou Email', minWidth: 140 },
  ]);
  const [openModal, setOpenModal] = useState(false);
  const [cidade, setCidade] = useState({});
  const [cidadesPorUF, setCidadesPorUF] = useState([]);
  const [estado, setEstado] = useState('');
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchCidade(cidade, newPage, limit);
  };

  const handleChangeRowsPerPage = (event) => {
    fetchCidade(cidade, 0, event.target.value);
  };

  const fetchCidade = async (cid, p = 0, l = 10) => {
    setPage(p);
    setLimit(l);
    console.log(cid || {});
    setCidade(cid || {});
    if (cid) {
      const i = cid.municipio ? cid.municipio.id : cid.ibge;
      setReady(false);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/cidadeEmail?ibge=${i}&limit=${l}&page=${p}`)
        .then((res) => {
          setCount(res.data.empresas.count);
          setEmpresas(res.data.empresas.rows);
          setCidadesEmail(res.data.cidadeEmail ? res.data.cidadeEmail : {});
          setReady(true);
        })
        .catch((err) => {
          setReady(true);
          setMsgAlert('Erro ao buscar dados, tente novamente mais tarde!');
          setTypeAlert('error');
          setAlert(true);
          console.log(err);
        });
    } else {
      console.log({});
      setCidadesEmail({});
    }
  };

  const saveCidadeEmail = async () => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/cidadeEmail`, cidadesEmail)
      .then(async (res) => {
        setMsgAlert(res.data.message);
        setTypeAlert('success');
        setAlert(true);
        setOpenModal(false);
        await fetchCidade(cidadesEmail);
      })
      .catch((err) => {
        setReady(true);
        setMsgAlert('Erro ao salvar dados, tente novamente mais tarde!');
        setTypeAlert('error');
        setAlert(true);
        console.log(err);
      });
  };

  const clickAlert = () => {
    setMsgAlert('');
    setTypeAlert('');
    setAlert(false);
  };

  const openCidadeEmail = () => {
    clickAlert();
    if (isEmptyObject(cidadesEmail)) {
      const obj = {
        id: null,
        uf: estado,
        cidade: cidade.nome,
        ibge: cidade.municipio.id.toString(),
      };
      setCidadesEmail(obj);
    }
    setOpenModal(true);
  };

  const handleClose = () => {
    clickAlert();
    setOpenModal(false);
    setReady(true);
  };

  const setUF = async (event) => {
    setReady(false);
    setEstado(event.target.value);
    const c = await IBGE.buscarCidades(event.target.value);
    // console.log(c);
    setCidadesPorUF(c);
    setReady(true);
    await fetchCidade(null);
  };

  const sendEmail = async (cnpj) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/sendEmailPrefeitura`, {
        cnpj,
      })
      .then(async (res) => {
        setMsgAlert(res.data.message);
        setTypeAlert('success');
        setAlert(true);
        await fetchCidade(cidade);
      })
      .catch((err) => {
        setReady(true);
        setMsgAlert('Erro ao enviar email, tente novamente mais tarde!');
        setTypeAlert('error');
        setAlert(true);
        console.log(err);
      });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 20,
      }}
    >
      <Snackbar open={alert} autoHideDuration={6000} onClose={clickAlert}>
        <Alert severity={typeAlert} onClose={clickAlert}>
          {msgAlert}
        </Alert>
      </Snackbar>
      <h1>Email Prefeitura</h1>
      <Paper style={{ width: '95%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: 10,
          }}
        >
          <Grid container>
            <TextField
              id="standard-select-currency"
              variant="outlined"
              select
              style={{ margin: 8, minWidth: '60px' }}
              label="Estado"
              value={estado}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={setUF}
            >
              {UFS.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <Autocomplete
              id="autoCompleteCupom"
              options={cidadesPorUF}
              getOptionLabel={(option) => option.nome}
              value={cidade ? cidade.nome : ''}
              onChange={(event, value) => fetchCidade(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{ margin: 8, minWidth: '120px' }}
                  label="Cidade"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Button
            variant="contained"
            size="large"
            disabled={isEmptyObject(cidade)}
            startIcon={<LocationCityIcon />}
            onClick={openCidadeEmail}
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
          >
            Modelo
          </Button>
        </div>
        <Collapse in={ready}>
          {Object.keys(cidadesEmail).length !== 0 ? (
            <>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align="center"
                        style={{
                          minWidth: column.minWidth,
                          fontWeight: 'bold',
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {empresas.map((e) => {
                    return (
                      <TableRow key={e.id}>
                        <TableCell component="th" scope="row" align="center">
                          {e.UsuarioEmpresa ? e.UsuarioEmpresa.User.nome : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {e.razao_social}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {e.cnpj}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {e.EmpresaUsuarioNFE &&
                          !e.EmpresaUsuarioNFE.email_enviado ? (
                            <IconButton
                              onClick={() => sendEmail(e.cnpj)}
                              style={{
                                color: XMEI_PRIMARY_COLOR,
                              }}
                              aria-label="Enviar Email"
                            >
                              <EmailIcon />
                            </IconButton>
                          ) : (
                            <IconButton
                              style={{
                                color:
                                  e.EmpresaUsuarioNFE &&
                                  e.EmpresaUsuarioNFE.inscricao_municipal
                                    ? 'green'
                                    : 'red',
                              }}
                              onClick={() => {
                                const msg =
                                  e.EmpresaUsuarioNFE &&
                                  e.EmpresaUsuarioNFE.inscricao_municipal
                                    ? 'Email Já enviado!'
                                    : 'Preencha todos os dados para enviar o email!';
                                setMsgAlert(msg);
                                setTypeAlert('info');
                                setAlert(true);
                              }}
                            >
                              <BlockIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </>
          ) : (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Typography variant="h5" gutterBottom>
                {cidade.nome ? 'Cidade não possui modelo salvo!' : ''}
              </Typography>
            </Grid>
          )}
        </Collapse>
        <Collapse in={!ready}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>

      <Modal open={openModal} onClose={handleClose}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
          className={classes.paper}
        >
          <Grid item xs={12}>
            <div align="center">
              <h1>Modelo Email</h1>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div align="center">
              <TextField
                id="email"
                label="Email"
                fullWidth
                style={{ width: '60%' }}
                variant="outlined"
                onChange={(event) => {
                  const obj = { ...cidadesEmail };
                  obj.email = event.target.value;
                  setCidadesEmail(obj);
                }}
                value={cidadesEmail.email}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div align="center">
              <TextField
                id="assunto"
                label="Assunto"
                fullWidth
                style={{ width: '60%' }}
                variant="outlined"
                onChange={(event) => {
                  const obj = { ...cidadesEmail };
                  obj.assunto = event.target.value;
                  setCidadesEmail(obj);
                }}
                value={cidadesEmail.assunto}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div align="center">
              <TextField
                id="conteudo"
                label="Conteudo"
                multiline
                rows={8}
                fullWidth
                style={{ width: '80%' }}
                variant="outlined"
                onChange={(event) => {
                  const obj = { ...cidadesEmail };
                  obj.conteudo = event.target.value;
                  setCidadesEmail(obj);
                }}
                value={cidadesEmail.conteudo}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div align="center">
              <Button
                variant="contained"
                style={{
                  backgroundColor: XMEI_PRIMARY_COLOR,
                  color: '#FFF',
                }}
                size="large"
                startIcon={<SaveIcon />}
                onClick={saveCidadeEmail}
              >
                Salvar
              </Button>
            </div>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
}

export default EmailPrefeitura;
